module.exports = __webpack_public_path__ + "img/level_one.c386631a.png";